import { render, staticRenderFns } from "./EcommerceCompanyTransactionsTable.vue?vue&type=template&id=336ac055&scoped=true&"
import script from "./EcommerceCompanyTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceCompanyTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCompanyTransactionsTable.vue?vue&type=style&index=0&id=336ac055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ac055",
  null
  
)

export default component.exports